/* eslint-env browser */
import React from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import config from "config/config.js";

export class BaseFooterWebSummit extends React.Component {
  static get NAME() {
    return "BaseFooterWebSummit";
  }
  // constructor(props) {
  //   super(props);
  // }
  render() {
    // const t = this.props.t;
    return (
      <div>
        <a
          href="https://websummit.com/featured-startups#foodiestrip-srl"
          title="Web Summit Foodiestrip"
          target="blank"
        >
          <img
            alt="foodiestrip web summit"
            src={`${config.imageRoot}landing_business/Beta.png`}
            title="Web Summit Foodiestrip"
            style={{ width: "100%", maxWidth: "220px" }}
          />
        </a>
      </div>
    );
  }
}

BaseFooterWebSummit.propTypes = {
  language: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
};

const FooterWebSummit = translate()(BaseFooterWebSummit);
export default FooterWebSummit;



// WEBPACK FOOTER //
// ./src/components/Footer/FooterWebSummit.jsx